export default __webpack_public_path__ + "static/media/Hair_20_F_C1.56ec4c52.svg";